import _ from "lodash";
import { MIME_TYPES_AND_FILE_EXTENSION } from '../../config/constants';
import languageModel from "../../models/language.model";

/**
 * @deprecated
 * 
 * To be re-written.
 */
export default function FileUploadComponent() {

    let _isOnlySingleFileUpload = false;
    let _instructionMessage = languageModel.getText("LT00000065", "Upload multiple files with the file dialog or by dragging and dropping files onto the dashed region.");
    let _totalFileSizeLimit = 10485760; // Unit: bytes (1048570 Bytes = 10 MiB)
    let _acceptableFileTypes = []; // Empty array means all file types are acceptable
    let _formData = new FormData();
    let _uploadedFiles = [];
    let _dropArea;
    let needReset = true;
    let _totalFileSize = 0;
    let _rejectedFiles = [];
    let _rejectedFilesDueToSingleFileUpload = [];

    let _onGettingFiles = (e) => { };

    let _preventDefaults = (e) => {
        e.preventDefault();
        e.stopPropagation();
    }

    let _highlight = () => {
        _dropArea.classList.add('border-success')
    }

    let _unhighlight = () => {
        _dropArea.classList.remove('border-success')
    }

    let _handleDrop = (e) => {
        _unhighlight();

        var dt = e.dataTransfer;
        var files = dt.files;

        _handleFiles(files);
    }

    let _handleFiles = (files) => {
        let _fileNames = [];
        _rejectedFiles = [];
        _rejectedFilesDueToSingleFileUpload = [];

        if (_isOnlySingleFileUpload && files.length > 1) {
            for (var i = 0; i < files.length; i++) {
                _rejectedFilesDueToSingleFileUpload.push(files[i].name);
            }

            _redrawData();
            return;
        }

        for (var i = 0; i < _uploadedFiles.length; i++) {
            _fileNames.push(_uploadedFiles[i].name);
        }

        let _processedFiles = [];

        for (var i = 0; i < files.length; i++) {
            if (_fileNames.indexOf(files[i].name) < 0) {
                _processedFiles.push(files[i]);
            }
        }

        if (_acceptableFileTypes && _acceptableFileTypes.length > 0) {

            let _finalisedFiles = [];

            for (var i = 0; i < _processedFiles.length; i++) {
                let _fileTypeItem = MIME_TYPES_AND_FILE_EXTENSION.find(item => item.mimeType == _processedFiles[i].type);

                if (typeof _fileTypeItem !== 'undefined' && _acceptableFileTypes.indexOf(_fileTypeItem.extension) >= 0) {
                    _finalisedFiles.push(_processedFiles[i]);
                } else {
                    _rejectedFiles.push(_processedFiles[i]);
                }
            }

            _finalisedFiles.forEach(_uploadFile);
            _finalisedFiles.forEach(_previewFile);

            if (_finalisedFiles.length == 0) {
                _redrawData();
            }

        } else {

            _processedFiles.forEach(_uploadFile);
            _processedFiles.forEach(_previewFile);

            if (_processedFiles.length == 0) {
                _redrawData();
            }

        }

    }

    let _uploadFile = (file, i) => {
        if (_isOnlySingleFileUpload) {
            _formData = new FormData();
        }

        _formData.append('file', file);
    }

    let _previewFile = (file) => {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = function () {
            _updateFileObject();
            needReset = false;

            setTimeout(() => {
                needReset = true;
                m.redraw();

            }, 1000);
        }
    }

    let _updateFileObject = () => {
        let formFiles = _formData.getAll("file");
        _totalFileSize = 0;
        _uploadedFiles = [];

        formFiles.forEach(function (file, i) {
            _totalFileSize = _totalFileSize + file.size;
            _uploadedFiles.push({ name: file.name, checked: false, index: i, size: file.size });
        });

        if (_totalFileSize > _totalFileSizeLimit) {
            _onGettingFiles([]);
        } else {
            _onGettingFiles(formFiles);
        }
    }

    let _checkAllAttachments = (e) => {
        _uploadedFiles.forEach(function (element) {
            element.checked = e.target.checked;
        });
    }

    let _filterFileArrbyChecked = (checked) => {
        return _uploadedFiles.filter(function (v) {
            return v["checked"] === checked;
        });
    }

    let _filterFromFilesbyName = (formFiles, name) => {
        return formFiles.filter(function (v) {
            return v["name"] != name;
        });
    }

    let _removeFiles = () => {
        let newFormData = new FormData();
        let formFiles = _formData.getAll("file");
        if (_filterFileArrbyChecked(true).length > 0) {

            _uploadedFiles.forEach(function (file) {
                if (file.checked) {
                    formFiles = _filterFromFilesbyName(formFiles, file.name);
                }

            });
            formFiles.forEach(function (file, i) {
                newFormData.append("file", file);
            })

            _formData = newFormData;
            _redrawData();
        }

    }

    let _removeFile = (index) => {
        let newFormData = new FormData();

        let formFiles = _formData.getAll("file");
        formFiles.splice(index, 1);
        formFiles.forEach(function (v, i) {
            newFormData.append("file", v);
        });
        _formData = newFormData;
        _redrawData();
    }

    let _redrawData = () => {
        _updateFileObject();
        needReset = false;
        setTimeout(() => {
            needReset = true;
            m.redraw();
        }, 100);
    }

    return {
        oninit: (vnode) => {
            if (vnode.attrs.isOnlySingleFileUpload) {
                _isOnlySingleFileUpload = true;
                _instructionMessage = languageModel.getText("LT00000065XX", "Upload ONLY ONE file with the file dialog or by dragging and dropping ONLY ONE file onto the dashed region.");
            }

            if (vnode.attrs.instructionMessage) {
                _instructionMessage = vnode.attrs.instructionMessage;
            }

            if (vnode.attrs.totalFileSizeLimit) {
                _totalFileSizeLimit = vnode.attrs.totalFileSizeLimit;
            }

            if (vnode.attrs.acceptableFileTypes) {
                _acceptableFileTypes = vnode.attrs.acceptableFileTypes;
            }

            if (vnode.attrs.onGettingFiles) {
                _onGettingFiles = vnode.attrs.onGettingFiles;
            }
        },
        oncreate: function (vnode) {
            _dropArea = document.getElementById("drop-area");
        },
        view: (vnode) => {
            let _isTotalFileSizeExceeded = _totalFileSize > _totalFileSizeLimit;

            return [
                m('#drop-area', {
                    oncreate: (vnode) => {

                        vnode.dom.addEventListener('dragenter', _preventDefaults, false);
                        vnode.dom.addEventListener('dragover', _preventDefaults, false);
                        vnode.dom.addEventListener('dragleave', _preventDefaults, false);
                        vnode.dom.addEventListener('drop', _preventDefaults, false);

                        vnode.dom.addEventListener('dragenter', _highlight, false);
                        vnode.dom.addEventListener('dragover', _highlight, false);

                        vnode.dom.addEventListener('dragleave', _unhighlight, false);
                        vnode.dom.addEventListener('drop', _handleDrop, false);

                    }
                },
                    [
                        m('p', _instructionMessage),
                        m('input[type="file"][id="fileElem"]' + (!_isOnlySingleFileUpload ? '[multiple]' : ''), {
                            onchange: (e) => {
                                _handleFiles(e.target.files)
                            }
                        }),
                        m('label.button[for="fileElem"]',
                            !_isOnlySingleFileUpload ?
                                languageModel.getText("LT00000066", "Select Files") :
                                languageModel.getText("LT00000374", "Select File")
                        ),
                        _uploadedFiles.length > 0 && m('.card.mt-4' + (_isTotalFileSizeExceeded ? '.border-danger' : ''),
                            { style: 'font-size: 0.875em;' },
                            m('.card-header.py-2.px-3',
                                m('.d-flex',
                                    m('.flex-grow-1',
                                        m('.form-check',
                                            m('input.form-check-input.me-2.mt-1 .checkBoxMargin_ [type="checkbox"]',
                                                {
                                                    onchange: e => {
                                                        _checkAllAttachments(e);
                                                    }
                                                }),
                                            m('label.form-check-label',
                                                m('i.bi bi-trash[role="button"]', { onclick: () => { _removeFiles() } }, languageModel.getText("LT00000373", "Remove Selected"))
                                            )
                                        )
                                    ),
                                    m('div' + (_isTotalFileSizeExceeded ? '.text-danger' : ''),
                                        m('span', 'Total File Size: ' + _totalFileSize.toLocaleString() + ' / ' + _totalFileSizeLimit.toLocaleString())
                                    )
                                ),
                            ),
                            m('.card-body.px-3' + (_isTotalFileSizeExceeded ? '.text-danger' : '') + '',
                                needReset && _uploadedFiles.map((file, i) =>
                                    [
                                        m('.col-md-10.actionRow',
                                            m('.form-check.form-check-inline',
                                                m('input.form-check-input[type="checkbox"]',
                                                    {
                                                        checked: file.checked,
                                                        onchange: e => {
                                                            file.checked = e.target.checked
                                                        }
                                                    }
                                                ),
                                                m('label.form-check-label', file.name + " (Size: " + file.size + " bytes)")),
                                            m('span.float-right', m('i.bi.bi-x', { onclick: () => { _removeFile(i) } })),
                                            m('.clearFloat')
                                        )
                                    ]
                                )
                            )
                        ),
                        _isTotalFileSizeExceeded && m('.alert.alert-danger.mt-3', { role: "alert" }, languageModel.getText("LT00000065XX", "Exceeded the total file size limit.")),
                        _rejectedFiles.length > 0 && m('.alert.alert-danger.mt-3', { role: "alert" }, [
                            m('p', languageModel.getText("LT00000065XX", "The following files have file types which are not accepted.")),
                            m('ul', { style: 'list-style-type: disc;' }, _rejectedFiles.map(function (file, index) {
                                return m('li', file.name);
                            }))
                        ]),
                        _rejectedFilesDueToSingleFileUpload.length > 0 && m('.alert.alert-danger.mt-3', { role: "alert" }, [
                            m('p', languageModel.getText("LT00000065XX", "Please upload ONLY ONE file."))
                        ]),
                        _acceptableFileTypes.length > 0 && m('p.mt-3', languageModel.getText("LT00000065XX", "Only allowing files with the format: ") + _acceptableFileTypes.join(", ")),
                    ])
            ]
        }
    }
}
